<template>
  <div
    class="recharge-type-tabs"
    :class="{ compact }"
    role="tablist"
    aria-label="Top-up currency"
  >
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="recharge-type-tab"
      :class="{ active: active === tab.value }"
      type="button"
      role="tab"
      :aria-selected="active === tab.value"
      @click="switchType(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  active: {
    type: String,
    required: true,
    validator: value => ['coins', 'gems'].includes(value),
  },
  compact: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['change'])

const tabs = [
  { label: 'Coins', value: 'coins' },
  { label: 'Gems', value: 'gems' },
]

function switchType(value) {
  if (value === props.active) return
  emit('change', value)
}
</script>

<style lang="scss" scoped>
.recharge-type-tabs {
  width: 326px;
  height: 54px;
  padding: 3px;
  border-radius: 27px;
  background: rgba(0, 0, 0, 0.3);
  display: grid;
  grid-template-columns: 160px 160px;
  box-sizing: border-box;
}

.recharge-type-tab {
  width: 160px;
  height: 48px;
  padding: 0;
  border: 0;
  outline: none;
  border-radius: 27px;
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &.active {
    background: #FDF652;
    color: #111111;
    cursor: default;
  }

}

.recharge-type-tabs.compact {
  width: 260.8px;
  height: 43.2px;
  padding: 2.4px;
  border-radius: 21.6px;
  grid-template-columns: 128px 128px;
  background: rgba(255, 255, 255, 0.14);

  .recharge-type-tab {
    width: 128px;
    height: 38.4px;
    border-radius: 21.6px;
    font-size: 12.8px;
  }
}
</style>
